import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux'
import { deleteItem, addNew, toggleShowOnlyFavorites, toggleFavorite, update, swapExercises, fixExercisesOrder } from "../store/exercisesSlice";
import { setResults, addNewResult, updateResult, deleteCheckedResults, appendResults } from "../store/resultsSlice";
import ExerciseCard from "./components/exercise-card";

import { Card, Tabs, Loader, Alert } from "@aws-amplify/ui-react";
import ExerciseDetailsCard from "./components/exercise-details-card";
import { useParams, useNavigate } from 'react-router-dom';
import EditExerciseForm from "./components/edit-exercise";
import ResultsCard from "./components/results-card";
import { Group, Panel, Separator } from 'react-resizable-panels';
import ResultsChart from "./components/results-chart";
import ExerciseDetailsHeader from "./components/exercise-details-header";
import { Accordion } from "@aws-amplify/ui-react";
import ExercisesHeader from "./components/exercises-header";
import { apiAddNewExercise, apiAddNewResult, apiDeleteExercise, apiFetchResults, apiUpdateExercise, apiUpdateResult, apiSwapExercises } from "../api/api";
import { useOutletContext } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";

const ExercisesPage = ({ searchText, exerciseEditor, createNewForm }) => {
    const dispatch = useDispatch()
    let params = useParams()
    const navigate = useNavigate()
    const { user } = useAuthenticator((context) => [context.user]);
    const { exercisesLoading } = useOutletContext((context) => {
        return context.exercisesLoading
    })
    const [selectedExercise, setSelectedExercise] = useState(null)
    const [groupedExercises, setGroupedExercises] = useState(null)
    const [resultsLoading, setResultsLoading] = useState(false)
    const [regroup, setRegroup] = useState(0)
    const [invalidateResults, setInvalidateResults] = useState(0)
    const [alert, setAlert] = useState(null)
    const [error, setError] = useState(null)


    const exercises = useSelector((state) => {
        return state?.exercises?.items
    })
    const maxOrder = useSelector((state) => {
        return state?.exercises?.maxOrder
    })
    const results = useSelector((state) => {
        return state?.results?.items
    })
    const showOnlyFavorites = useSelector((state) => state?.exercises?.showOnlyFavorites)

    const fetchResults = async (id) => {
        setResultsLoading(true)
        try {
            const response = await apiFetchResults(user.userId, id)
            dispatch(setResults({
                items: response?.data,
                id: id
            }
            ))
        } catch (e) {
            setError("Request 'GetResults' failed")
        } finally {
            setResultsLoading(false)
        }
    }
    const apiEnabled = useSelector((state) => state.exercises?.apiEnabled)
    useEffect(() => {
        if (exercises && apiEnabled) {
            if (params?.id) {
                setSelectedExercise(exercises.find((element) => element.id === params.id))
            }
            const filtered = (searchText.length > 0) ? exercises.filter((value, index, array) => (value.name.toLowerCase().includes(searchText.toLowerCase()))) : exercises
            const onlyFavorites = (showOnlyFavorites) ? filtered.filter((value) => value.favorite === true) : filtered
            const grouped = Object.groupBy(onlyFavorites, (item) => (item?.day || "undefined"))
            setGroupedExercises(grouped)
        }
    }, [exercises, params?.id || 0, regroup, searchText, showOnlyFavorites]);

    useEffect(() => {
        if (selectedExercise && apiEnabled) {
            if (!results[selectedExercise.id]) {
                //console.log('fetching results from server')
                fetchResults(selectedExercise.id)
            } else {
                //console.log('reusing local results')
            }
        }

    }, [selectedExercise, invalidateResults])


    return (
        <div>
            <Group direction="horizontal" >
                <Panel defaultSize={300} minSize={400} maxSize={800} style={{
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}>
                    <Card columnStart="1"
                        columnEnd="2"
                        className="h-100"
                        style={{
                            overflowY: 'auto',
                            overflowX: 'hidden'
                        }}
                        variation="elevated"                        >
                        <ExercisesHeader
                            onlyFavorites={showOnlyFavorites}
                            onOnlyFavoritesClicked={() =>
                                dispatch(toggleShowOnlyFavorites())
                            }
                        />

                        {groupedExercises && !exercisesLoading &&
                            <Accordion
                                defaultValue={Object.keys(groupedExercises).map((value, index) => `exercise-${index}-${value.id}`)}
                                allowMultiple
                                items={
                                    Object.keys(groupedExercises).sort((a, b) => a.localeCompare(b)).map((value, index, array) => ({
                                        trigger: (<h5>{value}</h5>),
                                        value: `exercise-${index}-${value.id}`,
                                        content: groupedExercises[value]?.sort((a, b) => {
                                            if (a.order !== b.order)
                                                return (a.order - b.order)
                                            else
                                                return a.timestamp - b.timestamp
                                        }).map((value, index, array) =>
                                            <ExerciseCard
                                                onClick={() => {
                                                    navigate(`/exercises/${value?.id}`)
                                                }}
                                                exercise={value}
                                                isSelected={value.id === params?.id}
                                                key={index}
                                                onUp={async () => {
                                                    if (array[index].order === array[index - 1].order) {
                                                        setError("Items have the same order attribute")
                                                        dispatch(fixExercisesOrder({
                                                            day: array[index].day,
                                                            user: user.userId
                                                        }))

                                                    }
                                                    else { //normal flow
                                                        apiSwapExercises(user.userId, array[index], array[index - 1])
                                                        dispatch(swapExercises({
                                                            current: array[index],
                                                            another: array[index - 1]
                                                        }))

                                                    }
                                                }}
                                                onDown={async () => {
                                                    if (array[index].order === array[index + 1].order) {
                                                        setError("Items have the same order attribute")
                                                        dispatch(fixExercisesOrder({
                                                            day: array[index].day,
                                                            user: user.userId
                                                        }
                                                        ))

                                                    } else { //normall flow
                                                        apiSwapExercises(user.userId, array[index], array[index + 1])
                                                        dispatch(swapExercises({
                                                            current: array[index],
                                                            another: array[index + 1]
                                                        }))

                                                    }
                                                }}
                                                isFirst={index === 0}
                                                isLast={index === array.length - 1}
                                            />)
                                    })
                                    )}
                            />}

                        {groupedExercises && ((Object.keys(groupedExercises).length || 0) === 0) && !exercisesLoading &&
                            <div>
                                {searchText &&
                                    <p>No exercises matching search criteria</p>
                                }
                                {!searchText &&
                                    <p>You have no exercises</p>
                                }
                            </div>
                        }

                        {exercisesLoading &&
                            <div>
                                <Loader className="me-1" />
                                <span>Loading..</span>
                            </div>
                        }

                    </Card>
                </Panel>
                <Separator style={{
                    width: '8px',
                    backgroundColor: '#e0e0e0',
                    cursor: 'col-resize',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}>
                    <div style={{
                        width: '4px',
                        height: '40px',
                        backgroundColor: '#999',
                        borderRadius: '4px'
                    }} />
                </Separator>
                <Panel defaultSize={70} >
                    <Card columnStart="2" columnEnd="-1" variation="elevated">
                        {!exerciseEditor &&
                            <>
                                <ExerciseDetailsHeader
                                    exercise={selectedExercise}
                                    onDelete={async (id) => {
                                        const exerciseToDelete = { ...selectedExercise }
                                        exerciseToDelete.deleted = true
                                        dispatch(deleteItem(id))
                                        await apiDeleteExercise(user.userId, exerciseToDelete)
                                        setAlert('Exercise was deleted')
                                    }}
                                    isLoading={resultsLoading}
                                    onFavoriteClicked={async () => {
                                        const updatedExercise = { ...selectedExercise }
                                        updatedExercise.favorite = !(updatedExercise.favorite || false)
                                        dispatch(toggleFavorite(selectedExercise.id))
                                        await apiUpdateExercise(user.userId, updatedExercise)
                                    }}>

                                </ExerciseDetailsHeader>

                                <Tabs
                                    spacing="relative"
                                    justifyContent="flex-end"
                                    defaultValue='Tab 1'
                                    items={[
                                        {
                                            label: 'Exercise Details', value: 'Tab 1',
                                            content: (
                                                <>
                                                    {!selectedExercise && <p>Select exercise from the list</p>}
                                                    {selectedExercise &&
                                                        <ExerciseDetailsCard
                                                            exercise={selectedExercise}
                                                            isLoading={resultsLoading} />}
                                                </>
                                            )
                                        },
                                        {
                                            label: 'Results', value: 'Tab 2', content: (
                                                <>
                                                    {!selectedExercise && <p>Select exercise from the list</p>}
                                                    {selectedExercise &&
                                                        <ResultsCard items={results}
                                                            isLoading={resultsLoading}
                                                            selected={selectedExercise}
                                                            onLoadMoreClicked={async () => {
                                                                //setResultsLoading(true)
                                                                try {
                                                                    const response = await apiFetchResults(user.userId, selectedExercise.id, results[selectedExercise.id]?.lastEvaluatedKey)
                                                                    dispatch(appendResults({
                                                                        items: response?.data,
                                                                        id: selectedExercise.id
                                                                    }
                                                                    ))
                                                                } catch (e) {
                                                                    setError("Request 'GetResults' failed")
                                                                } finally {
                                                                    //setResultsLoading(false)
                                                                }
                                                            }
                                                            }
                                                            onDeleteCheckedResults={(checkedResults) => {
                                                                dispatch(deleteCheckedResults({
                                                                    items: Array.from(checkedResults),
                                                                    exercise: selectedExercise.id
                                                                }
                                                                ))
                                                                setInvalidateResults(invalidateResults + 1)
                                                                setAlert('Results were deleted')
                                                            }

                                                            }
                                                            onUpdateResult={async (e) => {
                                                                dispatch(updateResult(e))
                                                                const { user, ...payload } = e;
                                                                await apiUpdateResult(user, payload)
                                                                setInvalidateResults(invalidateResults + 1)
                                                                setAlert('Results were updated')
                                                            }
                                                            }
                                                            onAddNewResult={async (e) => {
                                                                dispatch(addNewResult(e))
                                                                await apiAddNewResult(user, e)
                                                                setInvalidateResults(invalidateResults + 1)
                                                                setAlert('Result was added')
                                                            }} />}
                                                </>
                                            )
                                        },
                                        {
                                            label: 'Chart', value: 'Tab 3', content: (
                                                <>
                                                    {!selectedExercise && <p>Select exercise from the list</p>}
                                                    {selectedExercise &&
                                                        <ResultsChart results={results}
                                                            isLoading={resultsLoading}
                                                            selected={selectedExercise} />}
                                                </>
                                            )
                                        },
                                    ]}
                                />
                            </>
                        }
                        {exerciseEditor &&
                            <EditExerciseForm
                                element={createNewForm ? null : selectedExercise}
                                createNewForm={createNewForm}
                                onSave={async (element) => {

                                    if (!element.id) {
                                        element.id = crypto.randomUUID()
                                        element.deleted = false
                                        element.modified = Date.now()
                                        element.timestamp = Date.now()
                                        element.user = user.userId
                                        element.order = maxOrder + 1
                                        dispatch(addNew(element))
                                        await apiAddNewExercise(user.userId, element)
                                        setAlert("Item has been created")
                                    }
                                    else {
                                        const currentStateOfElement = exercises.find((value, index) => value.id === element.id)
                                        if (element.day !== currentStateOfElement.day) {
                                            element.order = maxOrder + 1
                                        }
                                        dispatch(update(element))
                                        await apiUpdateExercise(user.userId, element)
                                        setAlert("Item has been updated")
                                    }
                                    setRegroup(regroup + 1)
                                    navigate(`/exercises/${element.id}`)
                                }
                                } />
                        }
                    </Card>
                </Panel>
            </Group >
            {error &&
                <Alert
                    className="alert"
                    variation="error"
                    isDismissible={true}
                    hasIcon={true}
                    onDismiss={() => {
                        setError(null)
                    }}
                    heading="Error"
                >
                    {error}
                </Alert>
            }
            {alert &&
                <Alert
                    className="alert"
                    variation="success"
                    isDismissible={true}
                    hasIcon={true}
                    onDismiss={() => {
                        setAlert(null)
                    }}
                    heading="Success"
                >
                    {alert}
                </Alert>
            }
        </div>
    )

}

export default ExercisesPage;